import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../services/FormService';
import {RadioButton} from 'primeng/radiobutton';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-type',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    RadioButton
  ],
  template: `
    <div class="form-row">
      <label>
        {{ Yii.t('app', 'Form Type') }}
      </label>
      <div class="flex-col gap-8px">
        <div class="flex-row gap-8px">
          <p-radio-button [(ngModel)]="fsvc.form.type" value="1"/>
          <span>BOSS</span>
        </div>
        <div class="flex-row gap-8px">
          <p-radio-button [(ngModel)]="fsvc.form.type" value="0"/>
          <span>HR</span>
        </div>
      </div>
    </div>
  `
})
export class FormTypeComponent {
  Yii = Yii;

  constructor(public fsvc: FormService) {
  }

  onTypeChange(): void {
    this.fsvc.form.is_editable_after_submitting = false;
    this.fsvc.form.shared_form = false;
  }
}
